import { Link } from "react-router-dom";
import { Shield } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border/50 bg-background/80 backdrop-blur-sm mt-auto">
      <div className="container max-w-6xl mx-auto px-4 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand */}
          <div className="flex items-center gap-2">
            <Shield className="w-4 h-4 text-primary" />
            <span className="font-bold text-sm">LOWKEYX</span>
            <span className="text-xs text-muted-foreground">v1</span>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-4 sm:gap-6">
            <Link 
              to="/about" 
              className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Sobre Nosotros
            </Link>
            <Link 
              to="/legal" 
              className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Legal
            </Link>
            <Link 
              to="/legal?tab=privacy" 
              className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacidad
            </Link>
          </nav>

          {/* Copyright */}
          <p className="text-xs text-muted-foreground">
            © {currentYear} LOWKEYX · Desarrollado por <span className="text-foreground font-medium">Speatx</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
